import { makeStyles, Slider, withStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    // marginTop: spacing(5),
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'column',
    [breakpoints.up('lg')]: {
      margin: spacing(3, 15.75, 0, 15.75),
    },
    [breakpoints.down('lg')]: {
      margin: '30px',
    },
    // height: '100vh',
  },
  containerX: {
    [breakpoints.up('sm')]: {
      marginTop: '30px',
    },
  },
  confirmButton: {
    marginTop: spacing(4),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2, 0, 2, 2),
    letterSpacing: '0px',
    textTransform: 'unset',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0),
    },
  },
  confirmDisabledButton: {
    marginTop: spacing(4),
    backgroundColor: palette.gray.light,
    color: palette.green.main,
    width: spacing(15),
    margin: spacing(2, 0, 2, 2),
    letterSpacing: '0px',
    textTransform: 'unset',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0),
    },
  },
  logoImage: {
    width: '1000px',
    height: '100%',
    [breakpoints.down('sm')]: {
      left: spacing(9),
      width: 'auto',
      height: '100px',
      top: spacing(2),
      // padding: spacing(1),
      marginTop: spacing(2),
      display: 'flex',
    },
  },
  logoContainer: {
    [breakpoints.down('sm')]: {
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(6),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  subTitle: {
    margin: spacing(1),
    fontSize: spacing(3),
    fontWeight: spacing(87.5),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
    },
    '@media (max-width:400px)': {
      fontSize: spacing(1),
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1),
    },
  },
  errorText: {
    whiteSpace: 'pre-line',
    // marginBottom: spacing(-0.5),
    fontSize: spacing(1.75),
    color: palette.red.main,
    textAlign: 'center',
    minHeight: '60px',
    [breakpoints.down('sm')]: {
      marginTop: spacing(0.5),
      fontSize: spacing(1.7),
      whiteSpace: 'normal',
      minHeight: '45px',
    },
    '@media (max-width:400px)': {
      fontSize: spacing(1.5),
      marginTop: spacing(3),
      whiteSpace: 'normal',
      minHeight: '45px',
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.7),
      whiteSpace: 'normal',
      minHeight: '45px',
    },
  },
  hlsPlayer: {
    width: '800px',
    '@media (min-width:426px) and (max-width:825px)': {
      width: '99%',
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(2, 1),
    },
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  slider: {
    '@media (min-width:426px) and (max-width:825px)': {
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(2, 1),
    },
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  backButton: {
    marginTop: spacing(4),
    // backgroundColor: palette.green.dark,
    color: palette.green.main,
    border: `2px solid ${palette.green.dark}`,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.white.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(0),
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '800px',
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    [breakpoints.down('sm')]: {
      width: '400px',
      flexDirection: 'column-reverse',
      margin: spacing(2, 1),
      padding: spacing(1, 0),
    },
    '@media (min-width:426px) and (max-width:825px)': {
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(1),
    },
    '@media (max-width:375px)': {
      flexDirection: 'column-reverse',
      width: '330px',
    },
    '@media (max-width:320px)': {
      flexDirection: 'column-reverse',
      width: '280px',
    },
  },
  inTimeText: {
    marginLeft: '10px',
    marginRight: '20px',
  },
  outTimeText: {
    marginRight: '10px',
  },
  containerPlayer: {
    position: 'relative',
    margin: '0 auto',
    width: '800px',
    '@media (min-width:426px) and (max-width:825px)': {
      width: '99%',
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(2, 1),
    },
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Semi-transparent black
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '800px',
    '@media (min-width:426px) and (max-width:825px)': {
      width: '99%',
      margin: spacing(2, 1),
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(2, 1),
    },
    [breakpoints.only('lg')]: {
      width: '650px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  overlayText: {
    color: '#18a957',
    fontSize: '24px',
    fontWeight: 'bold',
    [breakpoints.down('sm')]: {
      fontSize: spacing(2),
    },
  },
  hlsPlayerLoader: {
    width: '800px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1000,
    '@media (min-width:426px) and (max-width:575px)': {
      margin: spacing(0, 1),
      top: '20%',
      position: 'absolute',
    },
    '@media (min-width:576px) and (max-width:960px)': {
      margin: spacing(0, 1),
      top: '30%',
      position: 'absolute',
    },
    '@media (min-width:376px) and (max-width:425px)': {
      width: '350px',
      margin: spacing(0, 1),
      top: '20%',
      position: 'absolute',
    },
    [breakpoints.up('md')]: {
      width: '650px',
      top: '30%',
      position: 'absolute',
    },
    '@media (max-width:375px)': {
      width: '330px',
      top: '20%',
      position: 'absolute',
    },
    '@media (max-width:320px)': {
      width: '280px',
      top: '25%',
      position: 'absolute',
    },
  },
  sliderContainer: {
    position: 'relative',
    // marginTop: '20px',
    // maxWidth: '800px',
    // width: '100%',
    flexShrink: 0,
    maxWidth: '800px',
    [breakpoints.down('sm')]: {
      width: '100%',
      padding: spacing(0.75),
      marginTop: '0px ',
    },
  },
  playerIndicator: {
    top: '10px', // Adjust based on slider height
    transform: 'translateX(-50%)',
    width: '15px',
    height: '15px',
    backgroundColor: '#C8C8C8', // Marker color
    // borderRadius: '50%',
    pointerEvents: 'none', // Prevent interfering with slider interaction
    transition: 'left 0.3s linear', // Smooth transition for marker movement
    position: 'absolute',
    [breakpoints.down('sm')]: {
      top: '22px', // Adjust based on slider height
    },
  },
}));

export const AudioSlider = withStyles({
  root: {
    height: 8,
    color: '#52af77',
    // '&.audioMismatch': {
    //   color: '#ff0000', // Red color if mismatch
    // },
    // '&.audioMatch': {
    //   color: '#52af77', // Default green color
    // },
  },
  thumb: {
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -7,
    marginLeft: -12,
    height: '20px',
    width: '20px',
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
      pointerEvents: 'none',
    },
    '& .MuiSlider-root': {
      height: 24,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
})(Slider);
